import { BreadcrumbList, ListItem } from "schema-dts"
import { META_DATA } from "src/metadata/constants"

export type BreadcrumbListItem = {
  name: string
  path: string
}

export type LastBreadcrumbListItem = {
  name: string
  path?: undefined
}

// https://developers.google.com/search/docs/appearance/structured-data/breadcrumb
export function createBreadcrumbsLd(
  items:
    | [BreadcrumbListItem, LastBreadcrumbListItem]
    | [BreadcrumbListItem, BreadcrumbListItem, LastBreadcrumbListItem],
) {
  const ld: BreadcrumbList = {
    // https://schema.org/BreadcrumbList
    "@type": "BreadcrumbList",
    itemListElement: items.map<ListItem>((item, index) => ({
      // https://schema.org/ListItem
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: item.path ? META_DATA.origin + item.path : undefined,
    })),
  }

  return ld
}
